export const OPTHINES = {
  voteName: '2020project/2020clapatwill',
  number: {
    mustRank: true,
  },
  themeColor: {
    activeBgColor: '#eac663',
    inactiveBgColor: '#fff',
  },
  tabs: [
    {
      tabName: '图片展示',
      tabPath: '/20200717CDWM/ListPage',
    },
    {
      tabName: '相关新闻',
      tabPath: '/20200717CDWM/News',
    },
    {
      tabName: '评选说明',
      tabPath: '/20200717CDWM/Rules',
    },
  ],
};
